
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"17","viewBox":"0.5 1.5 19 17","fill":"none","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.167 17.503A7.503 7.503 0 011.664 10a7.503 7.503 0 017.503-7.503A7.503 7.503 0 0116.67 10M2.092 7.499h14.15M2.092 12.501H10"}}),_c('path',{attrs:{"d":"M12.501 10c0-2.305-.603-4.61-1.806-6.62a1.763 1.763 0 00-3.056 0c-2.41 4.022-2.41 9.217 0 13.239.353.59.94.884 1.528.884M15.843 12.738l2.426 4.047c.218.364-.12.804-.54.704l-2.31-.55-2.309.55c-.42.1-.758-.34-.54-.704l2.426-4.047a.497.497 0 01.847 0z"}})])
          )
        }
      }
    